import { PageTitle } from "@/components/page-title";
import { CounterpartyForm } from "./_form";

function CounterpartyNew() {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <PageTitle>New counterparty</PageTitle>
      <CounterpartyForm />
    </div>
  );
}

export default CounterpartyNew;
